import { Component, Input, OnInit } from '@angular/core';
import { ThermometerData, ThermometerSetting, DailyData, MonthlyData } from '@dmonitor/shared/response/sensor/thermometer';
import { BaseComponent } from '@dmonitor/shared/index';
import { ModalController, ToastController, LoadingController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'thermometer-map-dialog',
  templateUrl: 'map-dialog.component.pug',
  styleUrls: ['map-dialog.component.sass'],
})
export class MapDialogComponent extends BaseComponent implements OnInit {
  protected TRANSLATE_KEY: string = "page.equipment.thermometer.map";
  @Input() Settings: ThermometerSetting;
  @Input() DailyData: DailyData[] = [];
  @Input() MonthlyData: MonthlyData[] = [];
  constructor(
    public modalController: ModalController,
    toastController: ToastController,
    loadingController: LoadingController,
    translateService: TranslateService) {
    super(toastController, loadingController, translateService);
  }

  public ngOnInit(): void {
    console.log(this.MonthlyData);
  }
  public parseInt(value:string):Number{
    return parseInt(value);
  }

  public dismiss() {
    this.modalController.dismiss();
  }

}